var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12.367",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -2)",
    d: "M7.81 2a6.184 6.184 0 1 1-5.176 9.542l.977-.773a4.938 4.938 0 1 0-.7-3.2h1.708L2.307 9.872 0 7.565h1.663A6.181 6.181 0 0 1 7.81 2m1.83 5.1a.57.57 0 0 1 .563.569v2.851a.571.571 0 0 1-.569.569H6.215a.571.571 0 0 1-.569-.569V7.664a.57.57 0 0 1 .562-.564v-.629a1.716 1.716 0 0 1 3.432 0V7.1M7.921 5.624a.848.848 0 0 0-.847.847V7.1h1.7v-.629a.85.85 0 0 0-.853-.847z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.9c95cb84f8e9d7d1ecdcb8c9cc0f08e0.svg";
export { ForwardRef as ReactComponent };